import { toDateTime, timeToMinutes, minutesToTime } from '../utils/date';

const icsStamp = (d) =>
  `${d.getUTCFullYear()}${String(d.getUTCMonth() + 1).padStart(2, '0')}${String(d.getUTCDate()).padStart(2, '0')}T${String(
    d.getUTCHours(),
  ).padStart(2, '0')}${String(d.getUTCMinutes()).padStart(2, '0')}00Z`;

const escape = (s = '') => String(s).replace(/[,;\\]/g, (m) => `\\${m}`).replace(/\n/g, '\\n');

/** Downloads an .ics file so the patient can add the visit to their phone calendar. */
export const downloadIcs = ({ appointment, clinic }) => {
  const start = toDateTime(appointment.date, appointment.time);
  const end = toDateTime(appointment.date, minutesToTime(timeToMinutes(appointment.time) + (appointment.duration || 30)));
  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Cloudkia//Patient Portal//EN',
    'BEGIN:VEVENT',
    `UID:${appointment.id}@patient-portal`,
    `DTSTAMP:${icsStamp(new Date())}`,
    `DTSTART:${icsStamp(start)}`,
    `DTEND:${icsStamp(end)}`,
    `SUMMARY:${escape(`Appointment with ${appointment.doctor?.name || 'doctor'}`)}`,
    `LOCATION:${escape(clinic?.address || '')}`,
    `DESCRIPTION:${escape(`${clinic?.name || ''}${appointment.reason ? ` — ${appointment.reason}` : ''}`)}`,
    'BEGIN:VALARM',
    'TRIGGER:-PT2H',
    'ACTION:DISPLAY',
    'DESCRIPTION:Appointment reminder',
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR',
  ];
  const blob = new Blob([lines.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `appointment-${appointment.date}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

const calendarService = { downloadIcs };
export default calendarService;
